<app-breadcrumb *ngIf="standalone" [crumbPaths]="[{
    name: 'Home',
    path: '/home'
}, {
    name: 'Client',
    path: '/client'
}, {
    name: 'Client details',
    path: '/client/detail',
    active: true
}]">
</app-breadcrumb>
<div class="row">
    <div class="col-4">
        <app-page-header title="Detail" [buttons]="[{
            icon: 'fa fa-arrow-left',
            name: 'Back',
            eventName: 'back'
        }, {
            name: 'Save',
            eventName: 'save'
        }]" (onButtonClick)="dataEventListener($event)"></app-page-header>
        <app-page-content>
            <div class="row">
                <div class="col-4">
                    <img class="w-100" style="border-radius: 8px"
                        src="https://st3.depositphotos.com/15648834/17930/v/450/depositphotos_179308454-stock-illustration-unknown-person-silhouette-glasses-profile.jpg" />
                </div>
                <div class="col-8">
                    <dx-text-box [(value)]="admin.firstName" placeholder="First Name" label="First Name"
                        class="mb-4"></dx-text-box>
                    <dx-text-box [(value)]="admin.lastName" placeholder="Last Name" label="Last Name"
                        class="mb-4"></dx-text-box>
                    <dx-text-box [(value)]="admin.email" required="true"
                        placeholder="Email" label="Email"></dx-text-box>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-6">
                    <dx-text-box placeholder="Legal Name" label="Legal Name" class="mb-4"
                        [(value)]="admin.legalName"></dx-text-box>
                    <dx-text-box placeholder="Trading Name" label="Trading Name" class="mb-4"
                        [(value)]="admin.tradingName"></dx-text-box>
                </div>
                <div class="col-6">
                    <dx-text-box placeholder="ABN" label="ABN" class="mb-4" [(value)]="admin.ABN"></dx-text-box>
                    <dx-text-box [(value)]="admin.phone" placeholder="Phone" label="Phone" class="mb-4"></dx-text-box>
                </div>
            </div>
            <dx-text-box placeholder="www.example.com" label="Website" [(value)]="admin.website"></dx-text-box>
        </app-page-content>
    </div>
    <div class="col-8">
        <app-page-content>
            <div>
                <dx-tabs #tabs [dataSource]="sideTabs"></dx-tabs>
            </div>
        </app-page-content>
        <app-page-content>
            <dx-multi-view [dataSource]="sideTabs" [(selectedItem)]="tabs.selectedItem" [loop]="false"
                [animationEnabled]="true">
                <div *dxTemplate="let data of 'item'">
                    <div *ngIf="data.text == 'Info'">
                        <ng-container *ngTemplateOutlet="info"></ng-container>
                    </div>
                    <div *ngIf="data.text == 'Locations'">
                        <ng-container *ngTemplateOutlet="locations"></ng-container>
                    </div>
                    <!-- <div *ngIf="data.text == 'Peoples'">
                        <ng-container *ngTemplateOutlet="peoples"></ng-container>
                    </div> -->
                    <div *ngIf="data.text == 'Surveys'">
                        <ng-container *ngTemplateOutlet="surveys"></ng-container>
                    </div>
                </div>
            </dx-multi-view>
        </app-page-content>
    </div>
</div>
<ng-template #locations>
    <div class="mb-2 p-2 row">
        <div class="col-12">
            <dx-button class="float-end" type="primary"
                (onClick)="editingAddress=null;panelVisible=true;">Add</dx-button>
        </div>
        <div class="col-lg-6 col-12 mb-2" *ngFor="let address of addresses">
            <div class="row mb-lg-0 m-4 p-2" (click)="onEditAddressClick(address)"
                style="cursor: pointer; border-left: 5px solid lightskyblue;">
                <div class="col-1 pt-2">
                    <i class="fa-solid fa-location-dot fa-2xl"></i>
                </div>
                <div class="col-11 media-body">
                    <h5 class="pmd-list-title mb-1">
                        Address <i class="fa-solid fa-pencil" style="color: blue;"></i>
                    </h5>

                    <p class="pmd-list-subtitle">
                        <strong>{{address.name}}</strong>
                        {{address.streetName}} {{address.streetNumber}}, <br />
                        {{address.locality}}, {{address.state}}<br />
                        {{address.country}}, {{address.zipcode}}
                    </p>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #info>
    <div class="row mb-2">
        <div class="col-6">
            <dx-select-box [disabled]="standalone == false" [(value)]="admin.broker" [items]="brokerList"
                displayExpr="name" valueExpr="_id" label="Broker"></dx-select-box>
        </div>
    </div>

    <div class="row">
        <div class="col-6">
            <div class="row">
                <div class="col-10">Exempt GST</div>
                <div class="col-2">
                    <dx-switch switchedOnText="Yes" switchedOffText="No" [(value)]="admin.exemptGST"></dx-switch>
                </div>
            </div>
        </div>
        <div class="col-6">
            <div class="row">
                <div class="col-10">Exempt Stamp Duty</div>
                <div class="col-2">
                    <dx-switch switchedOnText="Yes" switchedOffText="No" [(value)]="admin.exemptStampDuty"></dx-switch>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-2" *ngIf="currentUserRole != 'Client'">
        <div class="col-6">
            <div class="row">
                <div class="col-10">Account access</div>
                <div class="col-2">
                    <dx-switch switchedOnText="Yes" switchedOffText="No" [disabled]="standalone == false" [(value)]="admin.isActive"></dx-switch>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #surveys>
    <div class="row" *ngIf="standalone">
        <app-page-header [buttons]="[{
            name: 'Add New',
            eventName: 'add'
        }]" (onButtonClick)="action($event)"></app-page-header>
    </div>
    <div class="row">
        <app-data-grid [dataSource]="conductList" [config]="surveyConfig"
            (dataActionEvent)="action($event)"></app-data-grid>
    </div>
</ng-template>
<!-- <ng-template #peoples>
    <app-data-grid></app-data-grid>
</ng-template> -->


<app-slide-panel title="{{ this.editingAddress ? 'Edit' : 'Add' }}" [(visible)]="panelVisible" *ngIf="panelVisible">
    <app-location (onDone)="onLocation($event)" [latitude]="this.editingAddress?.latitude"
        [longitude]="this.editingAddress?.longitude" [name]="this.editingAddress?.name"
        [buildingNumber]="this.editingAddress?.buildingNumber" [streetName]="this.editingAddress?.streetName"
        [streetNumber]="this.editingAddress?.streetNumber" [locality]="this.editingAddress?.locality"
        [state]="this.editingAddress?.state" [country]="this.editingAddress?.country"
        [zipcode]="this.editingAddress?.zipcode"></app-location>
</app-slide-panel>

<dx-popup [width]="300" [height]="280" [showTitle]="true" title="Conducting Survey" [dragEnabled]="false"
    [hideOnOutsideClick]="true" [showCloseButton]="false" [(visible)]="surveyClientSelectPopup">
    <div *dxTemplate="let data of 'content'">
        <div class="mb-2">
            Survey
            <dx-select-box [(value)]="selectedSurvey" [items]="surveyList" displayExpr="name"
                valueExpr="_id"></dx-select-box>
        </div>
        <dx-button (onClick)="proceedToConduct()" class="w-100 bg-success">Proceed</dx-button>
    </div>
</dx-popup>